// load templates
require('./footer-template.html');

// create ngModule
angular.module('bbl.layout.footer', [])
  .controller('FooterController', ['$scope', 'Auth', '$cookies', '$window', function($scope, Auth, $cookies, $window){
    var impersonating = $cookies.get('impersonating');
    var _last = $cookies.get('_last');

    if (impersonating && _last) {
      $scope.impersonating = true;
      $scope.user = Auth.userInfo;
    }

    $scope.exitImpersonation = function() {
      Auth.exitImpersonation().then(function() {
        $window.location.replace("#/dashboard");
        $window.location.reload();
      });
    };
  }]);



/*****************
 ** WEBPACK FOOTER
 ** ./app/layout/footer-controller.js
 ** module id = 82
 ** module chunks = 0
 **/